import { Project } from "@brg/api";
import {FC, useMemo} from "react";
import { useTranslation } from "react-i18next";
import {AdaptiveCardWrapper} from "@brg/ui";
import { isServer } from 'shared/constants/isServer';
const CardComponent = isServer ? {} : require('adaptive-cards');

export const VoteCollectionCover: FC<{ project?: Project<'Global'> | Project<'Local'> }> = ({ project }) => {
    const { i18n } = useTranslation();

    //@ts-ignore
    const coverCard = useMemo(() => (project?.additionalInfo?.['super_puper_card'] && JSON.parse(project?.additionalInfo?.['super_puper_card'])), [project]);

    const images = useMemo(() => {
        if (!coverCard) return null;
        if (coverCard?.images) return coverCard?.images;
        return coverCard?.Images
    } , [coverCard]);

    const [collectionName] = useMemo(() => {
        if (!coverCard) return [''];

        if (coverCard?.collection) {
            return (coverCard?.collection?.name?.filter((i: any) => i?.name !== '' && i?.lang?.toLowerCase() === i18n.language) || ['']);
        }
        return (coverCard?.Collection?.Name?.filter((i: any) => i?.Name !== '' && i?.Lang?.toLowerCase() === i18n.language) || ['']);
    }, [coverCard, i18n])

    const cardProps = useMemo(() => ({
        data: {
            collectionName: collectionName?.name || collectionName?.Name || ""
        },
        templateType: "VotingCoverCardMain"
    }), [])

    if (!coverCard) {
        return null;
    }

    return (
        <AdaptiveCardWrapper cardProps={cardProps} images={images}>
            <CardComponent.MasterCard />
        </AdaptiveCardWrapper>
    );
}import { Project } from "@brg/api";
import {FC, useMemo} from "react";
import { useTranslation } from "react-i18next";
import {AdaptiveCardWrapper} from "@brg/ui";
import { isServer } from 'shared/constants/isServer';
const CardComponent = isServer ? {} : require('adaptive-cards');

export const VoteCollectionCover: FC<{ project?: Project<'Global'> | Project<'Local'> }> = ({ project }) => {
    const { i18n } = useTranslation();

    //@ts-ignore
    const coverCard = useMemo(() => (project?.additionalInfo?.['super_puper_card'] && JSON.parse(project?.additionalInfo?.['super_puper_card'])), [project]);

    const images = useMemo(() => {
        if (!coverCard) return null;
        if (coverCard?.images) return coverCard?.images;
        return coverCard?.Images
    } , [coverCard]);

    const [collectionName] = useMemo(() => {
        if (!coverCard) return [''];

        if (coverCard?.collection) {
            return (coverCard?.collection?.name?.filter((i: any) => i?.name !== '' && i?.lang?.toLowerCase() === i18n.language) || ['']);
        }
        return (coverCard?.Collection?.Name?.filter((i: any) => i?.Name !== '' && i?.Lang?.toLowerCase() === i18n.language) || ['']);
    }, [coverCard, i18n])

    const cardProps = useMemo(() => ({
        data: {
            collectionName: collectionName?.name || collectionName?.Name || ""
        },
        templateType: "VotingCoverCardMain"
    }), [])

    if (!coverCard) {
        return null;
    }

    return (
        <AdaptiveCardWrapper cardProps={cardProps} images={images}>
            <CardComponent.MasterCard />
        </AdaptiveCardWrapper>
    );
}